export const currencies = ["USD", "CRC"];
